// extracted by mini-css-extract-plugin
module.exports = {"CardGame":"CardGame_CardGame__1sGJ1","Message":"CardGame_Message__17Pf5","Hidden":"CardGame_Hidden__1d5Wp"};